import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { environment } from '../../../environments/environment';
import { JsonObjectFactoryService } from './json-object-factory.service';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root',
})
export class JcdFactoryService {
  GENERAL_CONFIG: any = {};

  params = { action_id: 80 };

  JCDFactory: any = {
    jcd_ta_key: null,
    JCDList: [],
    taskList: [],
    lists: {
      jurisdiction: '',
      domain: '',
      channel: '',
      task: '',
      activity: '',
    },
  };

  constructor(
    private jsonObjectFactory: JsonObjectFactoryService,
    private http: HttpClient
  ) {
    this.GENERAL_CONFIG = environment;
  }

  setList(num: number): void {
    if (num < 1) {
      this.JCDFactory.lists.jurisdiction = { list: [], selected: null, disabled: false };
    }
    if (num < 2) {
      this.JCDFactory.lists.domain = { list: [], selected: null, disabled: false };
    }
    if (num < 3) {
      this.JCDFactory.lists.channel = { list: [], selected: null, disabled: false };
    }
    if (num < 4) {
      this.JCDFactory.lists.task = { list: [], taskList: [], selected: null, disabled: false };
    }
    if (num < 5) {
      this.JCDFactory.lists.activity = { list: [], selected: null, disabled: true };
    }
  }

  setObj(num: any, _jcd_ta_key: any): void {
    this.setList(num);

    let _jur_key = this.JCDFactory.lists.jurisdiction.selected?.value || this.JCDFactory.lists.jurisdiction.selected || null;
    let _dom_key = this.JCDFactory.lists.domain.selected?.value || this.JCDFactory.lists.domain.selected || null;
    let _chan_key = this.JCDFactory.lists.channel.selected?.value || this.JCDFactory.lists.channel.selected || null;
    let _task_key = this.JCDFactory.lists.task.selected || null;
    let _activity_key = this.JCDFactory.lists.activity.selected?.value || this.JCDFactory.lists.activity.selected || null;

    const jcd_ta = _.find(this.JCDFactory.JCDList, (ii: any) => ii.ACTIVITY_KEY == _activity_key);
    this.JCDFactory.jcd_ta_key = jcd_ta ? jcd_ta.JCD_TA_KEY : null;

    if (_jcd_ta_key !== undefined) {
      const list = _.find(this.JCDFactory.JCDList, (i: any) => i.JCD_TA_KEY == _jcd_ta_key);
      if (list) {
        _jur_key = list.JURISDICTION_KEY;
        _dom_key = list.DOMAIN_KEY;
        _chan_key = list.CHANNEL_KEY;
        _task_key = list.TASK_KEY;
        _activity_key = list.ACTIVITY_KEY;
      }
    }

    _.forEach(this.JCDFactory.JCDList, (value: any) => {
      if (_.find(this.JCDFactory.lists.jurisdiction.list, { value: value.JURISDICTION_KEY }) === undefined) {
        const jobj = { name: value.JURISDICTION_CODE, value: value.JURISDICTION_KEY };
        this.JCDFactory.lists.jurisdiction.list.push(jobj);
        if (_jur_key === jobj.value) {
          this.JCDFactory.lists.jurisdiction.selected = jobj;
        }
      }

      if (_.find(this.JCDFactory.lists.domain.list, { value: value.DOMAIN_KEY }) === undefined) {
        const jobj = { name: value.DOMAIN_NAME, value: value.DOMAIN_KEY };
        this.JCDFactory.lists.domain.list.push(jobj);
        if (_dom_key == jobj.value) {
          this.JCDFactory.lists.domain.selected = jobj;
        }
      }

      if (_.find(this.JCDFactory.lists.channel.list, { value: value.CHANNEL_KEY }) === undefined) {
        const jobj = { name: value.CHANNEL_NAME, value: value.CHANNEL_KEY };
        if (value.DOMAIN_KEY === _dom_key) {
          this.JCDFactory.lists.channel.list.push(jobj);
        }
        if (_chan_key == jobj.value) {
          this.JCDFactory.lists.channel.selected = jobj;
        }
      }

      if (_.find(this.JCDFactory.lists.task.list, { value: value.TASK_KEY }) === undefined && _chan_key) {
        const jobj = {
          name: value.TASK_NAME,
          value: value.TASK_KEY,
          parent_task_key: value.PARENT_TASK_KEY,
          level: value.level,
          indent: value.indent,
        };
        if (value.CHANNEL_KEY === _chan_key) {
          this.JCDFactory.lists.task.list.push(jobj);
        }
        this.JCDFactory.lists.task.disabled = false;
        if (_task_key == jobj.value) {
          this.JCDFactory.lists.task.selected = _task_key;
        }
      }

      if (_.find(this.JCDFactory.lists.activity.list, { value: value.ACTIVITY_KEY }) === undefined && _task_key) {
        const jobj = { name: value.ACTIVITY_NAME, value: value.ACTIVITY_KEY };
        if (value.TASK_KEY === _task_key && value.CHANNEL_KEY === _chan_key) {
          this.JCDFactory.lists.activity.list.push(jobj);
        }
        this.JCDFactory.lists.activity.disabled = false;
        if (_activity_key == jobj.value) {
          this.JCDFactory.lists.activity.selected = jobj;
        }
      }
    });

    if (this.JCDFactory.lists.task.list.length > 0) {
      this.JCDFactory.lists.task.taskList = this.addIndent(_.cloneDeep(this.JCDFactory.lists.task.list));
    }
  }

  addIndent(list: any): any[] {
    const taskList: any[] = [];

    function transformToTree(items: any[]): any[] {
      const nodes: any = {};
      return items.filter((obj: any) => {
        const id = obj['value'];
        const parentId = obj['parent_task_key'];
        nodes[id] = _.defaults(obj, nodes[id], { children: [] });
        if (parentId) {
          (nodes[parentId] = nodes[parentId] || { children: [] })['children'].push(obj);
        }
        return !parentId;
      });
    }

    list = transformToTree(list);

    const times = (n: number, str: string) => {
      let result = '';
      for (let i = 0; i < n; i++) { result += str; }
      return result;
    };

    const recur = (item: any, level: number, arr: any[]) => {
      arr.push({
        name: item.name,
        value: item.value,
        task_name: item.name,
        task_key: item.value,
        level,
        indent: times(level, '\u00A0\u00A0\u00A0'),
      });
      if (item.children) {
        item.children.forEach((child: any) => recur(child, level + 1, arr));
      }
    };

    list.forEach((item: any) => recur(item, 0, taskList));
    return taskList;
  }

  loadJCDObj(): Promise<any> {
    return firstValueFrom(
      this.jsonObjectFactory
        .getJSONObj(environment.base_url + '/loadJsonObject', this.params, null, null)
    )
      .then((data: any) => {
        this.JCDFactory.JCDList = data.jsonObject;
        this.setObj(null, null);
        return data;
      });
  }
}
